/**
 * cart-drawer-insurance.js
 * ---------------------------------------------------
 * Prio+ verzekering-knop. Voegt/verwijdert de verzendverzekering
 * (variant 54398419173713) uit de winkelwagen.
 *
 * Luistert in de capture-fase op zowel 'click' als 'pointerup' zodat
 * andere scripts op de pagina de klik niet kunnen onderscheppen.
 */
(function () {
  const INSURANCE_VARIANT_ID = 54398419173713;
  let busy = false;

  async function getCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  async function addInsurance() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: INSURANCE_VARIANT_ID, quantity: 1 }] }),
    });
  }

  async function removeInsurance(cart) {
    const line = cart.items.findIndex((item) => item.variant_id === INSURANCE_VARIANT_ID) + 1;
    if (line === 0) return null;
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity: 0 }),
    });
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
    document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true, cancelable: false }));
  }

  async function handleToggle(btn) {
    if (busy) return;
    busy = true;
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");

    const isActive = btn.dataset.active === "true";
    try {
      const cart = await getCart();
      if (isActive) {
        await removeInsurance(cart);
      } else {
        await addInsurance();
      }
    } catch (err) {
      console.error("Prio+ toggle mislukt:", err);
    } finally {
      refreshDrawer();
      busy = false;
    }
  }

  function onPossibleToggleEvent(evt) {
    const btn = evt.target && evt.target.closest ? evt.target.closest("#cd-insurance-toggle") : null;
    if (!btn) return;
    handleToggle(btn);
  }

  document.addEventListener("click", onPossibleToggleEvent, true);
  document.addEventListener("pointerup", onPossibleToggleEvent, true);
})();
